import { Container } from 'inversify';
import { ChatService } from '@/services/chat-service';
import { TYPES } from '@/types';
import getDecorators from 'inversify-inject-decorators';
import {PlaceService} from "@/services/place-service";
import {CustomPlaceService} from "@/services/custom-place-service";
import {RoadLessonService} from "@/services/road-lesson-service";
import {OldRoadLessonService} from "@/services/old-road-lesson-service";
import {MenuService} from "@/services/menu-service";
import {ResourceService} from "@/services/resource-service";
import {SceneService} from "@/services/scene-service";
import {BattleLessonService} from "@/services/battle-lesson-service";
import {ExperienceService} from "@/services/experience-service";
import {ArtifactService} from "@/services/artifact-service";
import {ConsumableService} from "@/services/consumable-service";
import {BattleService} from "@/services/battle-service";
import {RuneService} from "@/services/rune-service";
import {ShopService} from "@/services/shop-service";
import {ArtifactNotificationService} from "@/services/artifact-notification-service";
import {RewardService} from "@/services/reward-service";
import {ArtifactLessonService} from "@/services/artifact-lesson-service";
import {TaskService} from "@/services/task-service";
import {HealthService} from "@/services/health-service";
import {PlayerSpeedService} from "@/services/player-speed-service";
import {ProfileService} from "@/services/profile-service";
import {PaymentNotificationService} from "@/services/payment-notification-service";
import {GameSoundService} from "@/services/game-sound-service";
import {PlayerCreatureService} from "@/services/player-creature-service";
import {EnemyCreatureService} from "@/services/enemy-creature-service";
import {CampaignService} from "@/services/campaign-service";
import {GenderChangeService} from "@/services/gender-change-service";
import {RenamePlayerService} from "@/services/rename-player-service";
import {MagicPlaceService} from "@/services/magic-place-service";
import {ClanService} from "@/services/clan-service";
import {ListService} from "@/services/list-service";
import {HeroShopService} from "@/services/hero-shop-service";
import {ForumService} from "@/services/forum-service";
import {GiftService} from "@/services/gift-service";
import {LawService} from "@/services/law-service";
import {LawServiceBeeline} from "@/services/law-service-beeline";
import {RateAppService} from "@/services/rate-app-service";
import {CapacitorService} from "@/services/capacitor-service";
import {LocationService} from "@/services/location-service";
import {HeroTownShopService} from "@/services/hero-town-shop-service";
import {TitanTownShopService} from "@/services/titan-town-shop-service";
import {PaymentChangeService} from "@/services/payment-change-service";
import {IapService} from "@/services/iap-service";
import {TenjinService} from "@/services/tenjin-service";
import {AppmetricaService} from "@/services/appmetrica-service";
import {MailOrPhoneService} from "@/services/mail-or-phone-service";
import {PasswordService} from "@/services/password-service";
import {AngelTownShopService} from "@/services/angel-town-shop-service";
import {YotunTownShopService} from "@/services/yotun-town-shop-service";
import {SurTownShopService} from "@/services/sur-town-shop-service";
import { EducationService } from "@/services/education-service";
import {AmetistShopService} from "@/services/ametist-shop-service";
import {WaterShopService} from "@/services/water-shop-service";
import {PortalShopService} from "@/services/portal-shop-service";
import {ShadowShopService} from "@/services/shadow-shop-service";
import {ForceNotificationService} from "@/services/force-notification-service";

const container = new Container();

container.bind<ChatService>(TYPES.ChatService).to(ChatService).inSingletonScope();
container.bind<PlaceService>(TYPES.PlaceService).to(PlaceService).inSingletonScope();
container.bind<CustomPlaceService>(TYPES.CustomPlaceService).to(CustomPlaceService).inSingletonScope();
container.bind<RoadLessonService>(TYPES.RoadLessonService).to(RoadLessonService).inSingletonScope();
container.bind<OldRoadLessonService>(TYPES.OldRoadLessonService).to(OldRoadLessonService).inSingletonScope();
container.bind<BattleLessonService>(TYPES.BattleLessonService).to(BattleLessonService).inSingletonScope();
container.bind<MenuService>(TYPES.MenuService).to(MenuService).inSingletonScope();
container.bind<ResourceService>(TYPES.ResourceService).to(ResourceService).inSingletonScope();
container.bind<SceneService>(TYPES.SceneService).to(SceneService).inSingletonScope();
container.bind<ExperienceService>(TYPES.ExperienceService).to(ExperienceService).inSingletonScope();
container.bind<ArtifactService>(TYPES.ArtifactService).to(ArtifactService).inSingletonScope();
container.bind<PlayerCreatureService>(TYPES.PlayerCreatureService).to(PlayerCreatureService).inSingletonScope();
container.bind<ConsumableService>(TYPES.ConsumableService).to(ConsumableService).inSingletonScope();
container.bind<BattleService>(TYPES.BattleService).to(BattleService).inSingletonScope();
container.bind<RuneService>(TYPES.RuneService).to(RuneService).inSingletonScope();
container.bind<ShopService>(TYPES.ShopService).to(ShopService).inSingletonScope();
container.bind<ArtifactNotificationService>(TYPES.ArtifactNotificationService).to(ArtifactNotificationService).inSingletonScope();
container.bind<ForceNotificationService>(TYPES.ForceNotificationService).to(ForceNotificationService).inSingletonScope();
container.bind<RewardService>(TYPES.RewardService).to(RewardService).inSingletonScope();
container.bind<ArtifactLessonService>(TYPES.ArtifactLessonService).to(ArtifactLessonService).inSingletonScope();
container.bind<TaskService>(TYPES.TaskService).to(TaskService).inSingletonScope();
container.bind<HealthService>(TYPES.HealthService).to(HealthService).inSingletonScope();
container.bind<PlayerSpeedService>(TYPES.PlayerSpeedService).to(PlayerSpeedService).inSingletonScope();
container.bind<ProfileService>(TYPES.ProfileService).to(ProfileService).inSingletonScope();
container.bind<PaymentNotificationService>(TYPES.PaymentNotificationService).to(PaymentNotificationService).inSingletonScope();
container.bind<GameSoundService>(TYPES.GameSoundService).to(GameSoundService).inSingletonScope();
container.bind<EnemyCreatureService>(TYPES.EnemyCreatureService).to(EnemyCreatureService).inSingletonScope();
container.bind<CampaignService>(TYPES.CampaignService).to(CampaignService).inSingletonScope();
container.bind<GenderChangeService>(TYPES.GenderChangeService).to(GenderChangeService).inSingletonScope();
container.bind<RenamePlayerService>(TYPES.RenamePlayerService).to(RenamePlayerService).inSingletonScope();
container.bind<MailOrPhoneService>(TYPES.MailOrPhoneService).to(MailOrPhoneService).inSingletonScope();
container.bind<PasswordService>(TYPES.PasswordService).to(PasswordService).inSingletonScope();
container.bind<MagicPlaceService>(TYPES.MagicPlaceService).to(MagicPlaceService).inSingletonScope();
container.bind<ClanService>(TYPES.ClanService).to(ClanService).inSingletonScope();
container.bind<ListService>(TYPES.ListService).to(ListService).inSingletonScope();
container.bind<HeroShopService>(TYPES.HeroShopService).to(HeroShopService).inSingletonScope();
container.bind<ForumService>(TYPES.ForumService).to(ForumService).inSingletonScope();
container.bind<GiftService>(TYPES.GiftService).to(GiftService).inSingletonScope();
container.bind<LawService>(TYPES.LawService).to(LawService).inSingletonScope();
container.bind<LawServiceBeeline>(TYPES.LawServiceBeeline).to(LawServiceBeeline).inSingletonScope();
container.bind<RateAppService>(TYPES.RateAppService).to(RateAppService).inSingletonScope();
container.bind<CapacitorService>(TYPES.CapacitorService).to(CapacitorService).inSingletonScope()
container.bind<LocationService>(TYPES.LocationService).to(LocationService).inSingletonScope()
container.bind<HeroTownShopService>(TYPES.HeroTownShopService).to(HeroTownShopService).inSingletonScope();
container.bind<TitanTownShopService>(TYPES.TitanTownShopService).to(TitanTownShopService).inSingletonScope();
container.bind<AngelTownShopService>(TYPES.AngelTownShopService).to(AngelTownShopService).inSingletonScope();
container.bind<PaymentChangeService>(TYPES.PaymentChangeService).to(PaymentChangeService).inSingletonScope();
container.bind<YotunTownShopService>(TYPES.YotunTownShopService).to(YotunTownShopService).inSingletonScope();
container.bind<SurTownShopService>(TYPES.SurTownShopService).to(SurTownShopService).inSingletonScope();
container.bind<AmetistShopService>(TYPES.AmetistShopService).to(AmetistShopService).inSingletonScope();
container.bind<WaterShopService>(TYPES.WaterShopService).to(WaterShopService).inSingletonScope();
container.bind<IapService>(TYPES.IapService).to(IapService).inSingletonScope();
container.bind<TenjinService>(TYPES.TenjinService).to(TenjinService).inSingletonScope();
container.bind<AppmetricaService>(TYPES.AppmetricaService).to(AppmetricaService).inSingletonScope();
container.bind<EducationService>(TYPES.EducationService).to(EducationService).inSingletonScope();
container.bind<PortalShopService>(TYPES.PortalShopService).to(PortalShopService).inSingletonScope();
container.bind<ShadowShopService>(TYPES.ShadowShopService).to(ShadowShopService).inSingletonScope();

const { lazyInject } = getDecorators(container);

export { container, lazyInject };
